export enum OrderSearchFilter {
  CLIENT = 'CLIENT',
  ID = 'ID',
  STATUS = 'STATUS',
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
  ORIGIN_LOCATION_GROUPS = 'ORIGIN_LOCATION_GROUPS',
  DESTINATION_LOCATION_GROUPS = 'DESTINATION_LOCATION_GROUPS',
  REQUESTED_PICKUP = 'REQUESTED_PICKUP',
  PICKUP_APPOINTMENT_REQUIRED = 'PICKUP_APPOINTMENT_REQUIRED',
  REQUESTED_DELIVERY = 'REQUESTED_DELIVERY',
  DELIVERY_APPOINTMENT_REQUIRED = 'DELIVERY_APPOINTMENT_REQUIRED',
  CREATED_DATE = 'CREATED_DATE',
  GL_CODE = 'GL_CODE',
  TAG = 'TAG',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  HAZMAT = 'HAZMAT',
  DIRECTION = 'DIRECTION',
  EQUIPMENT_TYPE = 'EQUIPMENT_TYPE',
  FREIGHT_ALLOWANCE_ENABLED = 'FREIGHT_ALLOWANCE_ENABLED',
  ASSIGNED_USERS = 'ASSIGNED_USERS',
  CANCELLATION_REASON = 'CANCELLATION_REASON',
  REQUESTED_MODE = 'REQUESTED_MODE',
  FREIGHT_ALLOWANCE = 'FREIGHT_ALLOWANCE',
  WEIGHT = 'WEIGHT',
  HANDLING_UNIT = 'HANDLING_UNIT',
  SOURCE = 'SOURCE',
  SWC = 'SWC',
  CUSTOMER_ROUTED = 'CUSTOMER_ROUTED',
  HOT = 'HOT',
}
